import { render, staticRenderFns } from "./ReportingArticle.vue?vue&type=template&id=8e8ad4ae&scoped=true&"
import script from "./ReportingArticle.vue?vue&type=script&lang=js&"
export * from "./ReportingArticle.vue?vue&type=script&lang=js&"
import style0 from "./ReportingArticle.vue?vue&type=style&index=0&id=8e8ad4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8ad4ae",
  null
  
)

export default component.exports